export function DevStepPicker({
  steps,
  step,
  go,
}: {
  steps: readonly string[]
  step: string
  go: (s: string) => void
}) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        background: 'rgba(0,0,0,0.85)',
        border: '1px solid #333',
        borderRadius: 10,
        padding: '8px 6px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        fontSize: 11,
        fontFamily: 'monospace',
      }}>
      <div style={{color: '#888', padding: '0 6px 4px', fontSize: 10}}>
        DEV steps
      </div>
      {steps.map(s => (
        <button
          key={s}
          onClick={() => go(s)}
          style={{
            background: s === step ? '#11E8B2' : 'transparent',
            color: s === step ? '#000' : '#ccc',
            border: 'none',
            borderRadius: 6,
            padding: '3px 8px',
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: 'monospace',
            fontSize: 11,
          }}>
          {s}
        </button>
      ))}
    </div>
  )
}
